import { render, staticRenderFns } from "./ex-brand.vue?vue&type=template&id=ebcac738&scoped=true&"
import script from "./ex-brand.vue?vue&type=script&lang=js&"
export * from "./ex-brand.vue?vue&type=script&lang=js&"
import style0 from "./ex-brand.vue?vue&type=style&index=0&id=ebcac738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcac738",
  null
  
)

export default component.exports